import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Label = styled.span<{ $active: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 1rem;
    font-weight: ${({ $active }) => ($active ? 600 : 500)};
`;

// Счётчик прямо в лейбле: сколько позиций и сколько категорий в стопе видно, не переключая
// вкладку — это первое, на что смотрят утром.
export const Badge = styled.span<{ $active: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 22px;
    padding: 0 7px;
    border-radius: ${radii.badge};
    font-size: 12px;
    font-weight: 700;
    background: ${({ $active }) => ($active ? colors.infoBg : "rgba(0,0,0,0.06)")};
    color: ${({ $active }) => ($active ? colors.primary : colors.textSecondary)};
`;
